module.exports = __webpack_public_path__ + "static/business_process_measurement-89a543f393f95236579d0a7c673f55b1.jpg";